/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free macro calculator. Turn a daily calorie target into grams of protein, carbohydrate and fat for a balanced, low-carb or high-protein split.`)
};

const es_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de macros gratuita. Convierte un objetivo calórico diario en gramos de proteína, carbohidratos y grasa con un reparto equilibrado, bajo en carbohidratos o alto en proteína.`)
};

const de_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Makro-Rechner. Wandle ein tägliches Kalorienziel in Gramm Protein, Kohlenhydrate und Fett um — für eine ausgewogene, kohlenhydratarme oder proteinreiche Verteilung.`)
};

const nl_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis macro calculator. Zet een dagelijks caloriedoel om in grammen eiwit, koolhydraten en vet voor een uitgebalanceerde, koolhydraatarme of eiwitrijke verdeling.`)
};

const fr_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de macros gratuit. Transformez un objectif calorique quotidien en grammes de protéines, glucides et lipides pour une répartition équilibrée, pauvre en glucides ou riche en protéines.`)
};

const it_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di macronutrienti gratuito. Trasforma un obiettivo calorico giornaliero in grammi di proteine, carboidrati e grassi per una ripartizione bilanciata, low-carb o ricca di proteine.`)
};

const pt_br2_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de macros gratuita. Transforme uma meta calórica diária em gramas de proteína, carboidrato e gordura para uma divisão equilibrada, low-carb ou hiperproteica.`)
};

const pt_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de macros gratuita. Transforme um objetivo calórico diário em gramas de proteína, hidratos de carbono e gordura, com divisão equilibrada, baixa em hidratos ou rica em proteína.`)
};

const ja_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のマクロ栄養素計算機。1日のカロリー目標をタンパク質・炭水化物・脂質のグラム数に変換し、バランス型・低炭水化物・高タンパクの配分を計算します。`)
};

const zh_macro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费三大营养素计算器。将每日热量目标转换为蛋白质、碳水化合物和脂肪的克数，支持均衡、低碳或高蛋白配比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_meta_description", locale)
	if (locale === "en") return en_macro_meta_description(inputs)
	if (locale === "es") return es_macro_meta_description(inputs)
	if (locale === "de") return de_macro_meta_description(inputs)
	if (locale === "nl") return nl_macro_meta_description(inputs)
	if (locale === "fr") return fr_macro_meta_description(inputs)
	if (locale === "it") return it_macro_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_macro_meta_description(inputs)
	if (locale === "pt") return pt_macro_meta_description(inputs)
	if (locale === "ja") return ja_macro_meta_description(inputs)
	return zh_macro_meta_description(inputs)
};